import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PlusIcon from "../../../assets/icons/PlusIcon";
import Spinner from "../../../assets/icons/Spinner";
import Message from "../../../i18n/Message";
import AssistantTile from "./list/AssistantTile";
import CreateAssistantDialog from "./list/CreateAssistantDialog";
import { loadAssistants } from "./store/assistantActionCreators";
import { assistantSelectors } from "./store/assistantReducer";
import NewWorkspaceLayout from "../layout/NewWorkspaceLayout";

import "./AssistantListPage.scss";

const AssistantListPage = () => {
  const [showCreate, setShowCreate] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { workspaceId } = useParams();
  const assistantList = useSelector(assistantSelectors.getList);
  const listCounter = useSelector(assistantSelectors.getListCounter);

  useEffect(() => {
    if (workspaceId) {
      dispatch(loadAssistants(intl, workspaceId));
    }
  }, [dispatch, intl, workspaceId, listCounter]);

  return (
    <NewWorkspaceLayout contentPanelClassName="assistant_list_page">
      <div className="breadcrumbs">&nbsp;</div>
      <h1>
        <Message id="menu_agents" />
      </h1>
      <div className="actions_panel">
        <button
          className="btn btn-outline-dark"
          onClick={() => setShowCreate(true)}
        >
          <PlusIcon size="18" color="#344767" />
          <Message id="create_assistant" />
        </button>
      </div>
      <div className="body_content">
        <div className="campaign_tiles">
          {!assistantList && <Spinner />}
          {assistantList && assistantList.length === 0 && (
            <div className="empty_state">
              <Message id="no_assistants_yet" />
            </div>
          )}
          {assistantList &&
            assistantList.map((assistant) => (
              <AssistantTile key={assistant.uid} assistant={assistant} />
            ))}
        </div>
      </div>
      {showCreate && (
        <CreateAssistantDialog onClose={() => setShowCreate(false)} />
      )}
    </NewWorkspaceLayout>
  );
};

export default AssistantListPage;
